module.exports = __webpack_public_path__ + "img/70.28494e9a.png";